import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDailyParameters = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 15,
	height: 15,
	viewBox: "0 0 15 15",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Rectangle_591",
		"data-name": "Rectangle 591",
		fill: "#fff",
		stroke: "#000",
		strokeWidth: 2,
		children: [/* @__PURE__ */ _jsx("rect", {
			width: 15,
			height: 15,
			stroke: "none"
		}), /* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 13,
			height: 13,
			fill: "none"
		})]
	})]
});
const ForwardRef = forwardRef(SvgDailyParameters);
export { ForwardRef as ReactComponent };
